import React, { useState, useEffect } from 'react'
import { Box, Card, Icon, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxToggleButton from './toggleButton'
import EditOverlay from './editOverlay'

const InactiveQuestion = ({
  handleDuplicate,
  handleQuesDelete,
  handleQues,
  handleFloatAddQuestion,
  handleFloatAddSection,
  valueType,
  valueRequired,
  valueQuestion,
  valueOption,
  quesKey,
  sectIndex,
  quesIndex,
  handleDrag,
  isDragging,
  sx,
  sxCard,
}) => {
  const [optionState, setOptionState] = useState(valueOption)
  const [editOverlay, setEditOverlay] = useState(false)

  useEffect(() => {
    setOptionState(valueOption)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueType])

  const renderQuestion = () => {
    switch (valueType) {
      case '1':
        return (
          <Box display="flex" flexDirection="column" gap={2.5}>
            <AdxInput value="" size="standard" placeholder="Text answer here" disabled />
          </Box>
        )
      case '2':
        return (
          <Box display="flex" flexDirection="column" gap={2.5}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <AdxToggleButton
                valueStart={optionState[0] ?? 1}
                valueEnd={optionState[1] ?? 5}
                labelStart={optionState[2] ?? '...'}
                labelEnd={optionState[3] ?? '...'}
                disabled
                sx={{ height: 45 }}
              />
            </Box>
          </Box>
        )
      case '3':
        return renderMultiple()
      case '4':
        return renderMultiple()
      default:
        break
    }
  }

  const renderMultiple = () => {
    return (
      <Box display="flex" flexDirection="column" gap={1.5}>
        {optionState.map((value, index) => (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              marginBottom: '20px',
            }}
            key={index}
          >
            <Icon
              sx={{
                marginRight: '16px',
                color: 'light-gray-text.main',
              }}
              disabled
            >
              {valueType === '3' ? 'radio_button_unchecked_icon' : 'check_box_outline_blank_icon'}
            </Icon>
            <Typography variant="body1" color={value !== '' ? 'dark-text.main' : 'error.main'}>
              {/* {value === "" ?
                <Icon
                  sx={{
                    color: 'error.main',
                    marginRight: '10px',
                    verticalAlign: 'bottom',
                  }}
                >
                  warning_icon
                </Icon>
              :
                null  
              } */}
              {value !== ''
                ? value
                : // `Option ${index + 1}`
                  'Answer option cannot be empty'}
            </Typography>
          </Box>
        ))}
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      position="relative"
      onMouseEnter={() => setEditOverlay(true)}
      onMouseLeave={() => setEditOverlay(false)}
    >
      {editOverlay && <EditOverlay />}
      <Card
        sx={{
          width: '100%',
          height: 'auto',
          p: 3,
          boxShadow: '0px 0px 10px lightgray',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'row',
          backgroundColor: 'white',
          gap: 5,
          ...sxCard,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            '&:hover': {
              cursor: 'move',
            },
          }}
          {...handleDrag}
        >
          <Icon
            sx={{
              color: 'light-gray-text-2.main',
            }}
          >
            drag_indicator_icon
          </Icon>
        </Box>
        <Box
          sx={{
            width: '100%',
          }}
          display="flex"
          flexDirection="column"
          gap={2.5}
        >
          <Typography
            variant="h4"
            color={valueQuestion ? 'dark-text.main' : 'error.main'}
            fontWeight="regular"
            noWrap={isDragging ? true : false}
            sx={
              isDragging
                ? { width: '90%', whiteSpace: 'pre-line' }
                : { width: 'auto', whiteSpace: 'pre-line' }
            }
          >
            {/* {valueQuestion === "" ?
              <Icon
                sx={{
                  color: 'error.main',
                  marginRight: '10px',
                  verticalAlign: 'bottom',
                }}
              >
                warning_icon
              </Icon>
              ) : null} */}
            {valueQuestion !== '' ? (
              <span>
                {valueQuestion} {valueRequired ? <span style={{ color: 'red' }}>*</span> : ''}
              </span>
            ) : (
              <span>
                Question cannot be empty{' '}
                {valueRequired ? <span style={{ color: 'red' }}>*</span> : ''}
              </span>
            )}
          </Typography>
          {isDragging ? (
            <Box>
              <Typography
                sx={{
                  textAlign: 'center',
                }}
              >
                . . .
              </Typography>
            </Box>
          ) : (
            renderQuestion()
          )}
        </Box>
      </Card>
    </Box>
  )
}

export default InactiveQuestion
